import { createComponent } from '../lib';
import { VmDblClickFullscreen } from '@vime/core';
import { define } from '../lib';
define('vm-dbl-click-fullscreen', VmDblClickFullscreen);
;
export default createComponent('vm-dbl-click-fullscreen', new Set(['useOnMobile', 'isFullscreenActive', 'isVideoView', 'playbackReady', 'isMobile']));
//# sourceMappingURL=DblClickFullscreen.jsx.map